import { Component, Input } from '@angular/core';
import { ProgressStatusBarComponent } from 'src/app/cms/pages/dashboard/progress-dialog/progress-status-bar/progress-status-bar.component';
import { ProgressStatusStepsComponent } from 'src/app/cms/pages/dashboard/progress-dialog/progress-status-steps/progress-status-steps.component';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { TourTrackType } from 'src/app/cms/pages/onboarding/guided-tour';
import {
  ProgressBarData,
  ProgressStep,
} from 'src/app/cms/pages/dashboard/dashboard-card-base.component';

export interface ProgressCard {
  tourType: TourTrackType;
  title: string;
  icon: string;
  steps: ProgressStep[];
  progress: ProgressBarData;
}

@Component({
  selector: 'qa-progress-card',
  templateUrl: './progress-card.component.html',
  styleUrl: './progress-card.component.scss',
  imports: [
    ProgressStatusBarComponent,
    ProgressStatusStepsComponent,
    MatIcon,
    TranslateModule,
  ],
})
export class ProgressCardComponent {
  @Input() progressCard: ProgressCard;
}
